import React from "react";

import ChromeExtensionWelcomeView from "@main/pages/ChromeExtension/views/ChromeExtensionWelcomeView";

export default function ChromeExtensionWelcomePage() {
  return <ChromeExtensionWelcomeView />;
}
